import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-navy-soft py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-262" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-263" data-mp="3fxb2ghka7obn">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-264" data-mp="3azjcvu740eam">
          Testimonials from Educators Using This Teacher Ready
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-265" data-mp="31zd3ajej7ygq">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-gold/30 bg-steel p-6 shadow-lg shadow-black/20" data-id="element-266" data-mp="2x1kzos4iynwp" data-mpi={index}>
              <div className="flex text-mineral" aria-label="5 out of 5 stars" data-id="element-267" data-mp="h4n2k87sbt9c">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-268" data-mp="780l7teo3kc2" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-269" data-mp="c7wo1pbmp5q1">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-270" data-mp="zxh9qfz62h30">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gold/50 bg-navy text-sm font-extrabold text-mineral" data-id="element-271" data-mp="14vsmayguj5ox">
                  {initials}
                </span>
                <span data-id="element-272" data-mp="v4emsqowa5vs">
                  <b className="block text-sm text-white" data-id="element-273" data-mp="v3mrzi34gc6k">{name}</b>
                  <small className="text-xs text-muted" data-id="element-274" data-mp="1iuifw44gin8j">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}